import AmbassadorsPage from './AmbassadorsPage'

export default AmbassadorsPage
// eslint-disable-next-line import/export
export * from './AmbassadorsPage'
